import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Button, Form, Input,Spin } from 'antd';
import styles from './ChangePassword.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGlobalLoading, useAuth } from 'hooks';
import { AuthService } from 'services';
import smallLogo from 'assets/images/allin1logoNoText.png';
import {
  LoadingOutlined,
  CloseCircleFilled,
  CheckCircleFilled
} from '@ant-design/icons';
import { useAuthModalStore } from 'modules/zustand/store';
import { showNotification } from 'services/NotificationService';
/* eslint-disable */
export interface ChangePasswordFormProps {
  password: string;
  confirmPassword: string;
}

interface ChangePasswordData {
  user_sub: string;
  password: string;
}


const ChangePasswordModal: FC = (): ReactElement => {
  const navigate = useNavigate();
  const [form] = Form.useForm<ChangePasswordFormProps>();
  const [formError, setFormError] = useState<string>('');
  const [pageLoading, setPageLoading ] = useState<boolean>(false);
  const [tokenError, setTokenError] = useState<{
    error_code: string;
    error_message: string;
  }>();

  const token = useAuthModalStore((state)=>state.passwordToken)
  const userSub = useAuthModalStore((state)=>state.userSub)

  const setOffPasswordModal = useAuthModalStore((state)=>state.setOffPasswordModal)
  const setOnLoginModal = useAuthModalStore((state)=>state.setOnLoginModal)

  const password = Form.useWatch('password', form);
  const [checkToken, setCheckToken] = useState(false);

  useEffect(() => {
    setFormError(tokenError?.error_message || '');
  }, [tokenError]);

  const fetchRegisterVerify = async (token: string, userSub: string) => {
    setPageLoading(true)
    try {
      const data = await AuthService.registerVerify(userSub, token);
      setPageLoading(false);
      setCheckToken(true);
    } catch (e: any) {
      setPageLoading(false);
      if (e.error_code === 'TOKEN_KEY_INVALID') {
        setFormError(e.error_message);
      } else {
        setFormError('');
      }
    }
  };



  useEffect(() => {
    token && fetchRegisterVerify(token, userSub);
  }, [token]);

  const onClickUpdate = (e: any) => {
    //  check password compare
    const password = form.getFieldsValue().password;
    const confirmPassword = form.getFieldsValue().confirmPassword;
    if (password == confirmPassword) {
      e.preventDefault();
      // Do action submit if form pass validate fields
      form.validateFields().then(hanldUpdate).catch(getError);
    } else {
      setFormError('');
    }
  };

  const hanldUpdate = async () => {
    // call API
    setPageLoading(true)
    try {
      const data = await AuthService.changePassword(userSub, password);
      setPageLoading(false);
      setOffPasswordModal()
      showNotification('', 'Password has been set successfully.');
      setOnLoginModal()
    } catch (e: any) {
      setPageLoading(false);
      setFormError('Invalid password format');
    }
  };

  const getError = () => {
    const errors = form
      .getFieldsError()
      .map((item) => item.errors)
      .reduce((prev, cur) => {
        return prev.concat(cur);
      }, []);
    setFormError(errors[0]);
  };

  const [upperCaseSas ,setUpperCaseSas] = useState(false)
  const [lowerCaseSas ,setLowerCaseSas] = useState(false)
  const [passLengtgSas ,setPassLengthSas] = useState(false)
  const [numericSas ,setNumericSas] = useState(false)

  const passWordCheck = (data:string) =>{
    (data.length >= 8) ? setPassLengthSas(true) :setPassLengthSas(false);
    setUpperCaseSas(/[A-Z]/.test(data));
    setLowerCaseSas(/[a-z]/.test(data));
    setNumericSas(/[0-9]/.test(data));
  }

  return (
    <div className="flex flex-col justify-center items-center my-2 gap-3">
      
      <div className="flex" style={{margin:'15px'}}>
            <img className="m-auto" style={{maxHeight:'70px'}} src={smallLogo} />
      </div>
      <h2 className='text-center'>Change Password</h2>
      <p className='!w-[300px]'>{tokenError?.error_message}</p>
      <Form
        form={form}
        name="basic"
        className="flex flex-col"
        initialValues={{ remember: true }}
        layout={'vertical'}
        size={'middle'}
        autoComplete="off"
      >
        {formError && (
          <div className="flex justify-center items-center bg-[#FFE0E0] h-[40px] mb-5">
            {formError}
          </div>
        )}
        {/* checkToken && */}
        {  (
          <div>
            {/*  Password */}
            
            <div className="flex flex-col mb-[20px] pl-">
                    <label className="text-sm font-bold mb-1">Password must have:</label>
                    <span className={`${upperCaseSas? 'text-green-500':'text-neutral-500'} transition-all duration-300 ease-in-out`}> {!upperCaseSas && (<CloseCircleFilled />)} {upperCaseSas && (<CheckCircleFilled />)} <span className='text-neutral-500'>Uppercase characters (A through Z)</span> </span>
                    <span className={`${lowerCaseSas? 'text-green-500':'text-neutral-500'} transition-all duration-300 ease-in-out`}> {!lowerCaseSas && (<CloseCircleFilled />)} {lowerCaseSas && (<CheckCircleFilled />)} <span className='text-neutral-500'>Lowercase characters (a through z)</span> </span>
                    <span className={`${numericSas? 'text-green-500':'text-neutral-500'} transition-all duration-300 ease-in-out`}> {!numericSas && (<CloseCircleFilled />)} {numericSas && (<CheckCircleFilled />)} <span className='text-neutral-500'>Numeric characters (0 through 9)</span> </span>
                    <span className={`${passLengtgSas? 'text-green-500':'text-neutral-500'} transition-all duration-300 ease-in-out`}> {!passLengtgSas && (<CloseCircleFilled />)} {passLengtgSas && (<CheckCircleFilled />)} <span className='text-neutral-500'>Password must have more than 7 characters</span> </span>
                </div>
              <label htmlFor="password" className={styles['form-item-label']}>
              Password: <span className="text-red-600">*</span>{' '}
             
            </label>
            <Form.Item
              className={styles['form-item']}
              name="password"
              rules={[
                { required: true, message: 'Please input your password!' },
              ]}
              validateTrigger={false}
            >
              <Input.Password
                id="password"
                className="!w-[300px] h-[40px] !rounded-md "
                onChange={(data)=>{passWordCheck(data.target.value)}}
              />
            </Form.Item>
            {/* Confirm Password */}
            <label htmlFor="password" className={styles['form-item-label']}>
              Confirm Password: <span className="text-red-600">*</span>
            </label>
            <Form.Item
              className={styles['form-item']}
              name="confirmPassword"
              rules={[
                { required: true, message: 'Please input Confirm Password!' },
              ]}
              validateTrigger={false}
            >
              <Input.Password
                id="confirmPassword"
                className="!w-[300px] h-[40px] !rounded-md "
              />
            </Form.Item>
            {/* Update */}
            <Form.Item className={styles['form-item']}>
              
              <button onClick={onClickUpdate}  type="button" className="w-full flex justify-center items-center shadow mt-3 border-none text-white bg-black hover:bg-neutral-200 hover:text-black hover:shadow-md font-[450] rounded-lg text-xl py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300" >
                  <LoadingOutlined  spin  className={`${pageLoading? '':'hidden'} text-xl mr-3`}/>Set Password
                </button>
            </Form.Item>
          </div>
        )}
      </Form>
    </div>
  );
};

export default ChangePasswordModal;
